import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      intersect: false,
    },
  },
  scales: {
    y: {
      display: false, // Hide Y axis labels
    },
    x: {
      grid: {
        display: false,
        color: "#75787B",
      },
      display: false, // x軸ラベル非表示
      ticks: {
        color: "white",
        maxRotation: 0,
        minRotation: 0,
        font: {
          size: 8,
        },
      },
    },
  },
};

export function DataContentChart({ inLabels, inDatasets }) {
  const labels = [];
  for (let j = 0; j < inLabels.length - 1; j++) {
    labels.push(inLabels[j] + " - " + inLabels[j + 1]);
  }

  // カンマを取り除く処理
  const cleanedDatasets = inDatasets.map((data) => {
    if (typeof data === "string") {
      return parseFloat(data.replace(/,/g, ""));
    }
    return data;
  });

  const data = {
    labels,
    datasets: [
      {
        data: cleanedDatasets,
        backgroundColor: "#75787B",
        color: "white",
      },
    ],
  };

  return (
    <div
      style={{
        height: "100px",
        width: "230px",
        display: "inline-block",
      }}
    >
      <Bar height={100} width={100} options={options} data={data} />
    </div>
  );
}

export function DataContentText({ inLabels, inDatasets }) {
  return (
    <List
      style={{
        minWidth: "150px",
        marginTop: "-6px",
      }}
      dense={true}
    >
      {inLabels.map((label, index) => (
        <ListItem key={index} style={{ width: "100%", padding: "4px 0px" }}>
          <Typography
            style={{
              color: "white",
              width: "70%",
              fontFamily: "Noto Sans JP, Meiryo, -apple-system",
            }}
          >
            {label}
          </Typography>
          <Typography
            style={{
              color: "white",
              width: "30%",
              textAlign: "right",
              paddingLeft: "10px",
              fontFamily: "Noto Sans JP, Meiryo, -apple-system",
            }}
          >
            {inDatasets[index]}
          </Typography>
        </ListItem>
      ))}
    </List>
  );
}
